
import React, { Component } from "react";

class Check extends Component {
    permission(data, type = 'and') {
        let data_=[`${data}`]

        // if (localStorage.getItem('role_id_ctv') === '1') { return true; }

        const permission = localStorage.getItem('permission_ctv') ? localStorage.getItem('permission_ctv').split(',') : [];
        if (data_?.length == 0) {
            return false;
        } else {
            let result = false;

            data_?.map((item, i) => {
                if (permission.length > 0) {
                    switch(type){
                        case 'or':
                            if (permission.indexOf(item) > -1) { result = true; }
                        break;

                        case 'and':
                            if (permission.indexOf(item) > -1) {
                                result = true;
                            } else {
                                result = false;
                            }
                        break;
                        default: result = false;
                    }
                }
            });

            return result;
        }
    }
}

export default Check;